<template>
	<page>
		<module title="分销设置">
			<c-form ref="form">
				<c-form-item type="image" label="分销海报图" name="share_img_list" limit="5" required file-word="建议尺寸：600×1000像素，格式支持：jpg、png，最多上传5张"></c-form-item>
				<c-form-item label="各等级分销奖励">
					<ul class="tab flex">
						<li v-for="(item, i) in levelList" :key="i" :class="{'z-crt': currentTab == i}" @click="currentTab = i">{{item.level_name}}</li>
					</ul>
					<div v-for="(item, i) in levelList" :key="i" v-show="currentTab == i" class="tab-content">
						<c-form style="padding: 30px 24px;">
							<c-form title="销售佣金设置" v-if="item.id != 10">
								<c-form-item v-if="item.id == 40" type="number" decimal="4" style="width:500px" label="业务员代理佣金比例" name="RATIO_40" v-model="RATIO_40" :limit="[0,20]" input-unit="%" word="按交易金额抽取对应比例作为业务员奖励"></c-form-item>
								<c-form-item v-if="item.id == 30" type="number" decimal="4" style="width:500px" label="省代代理佣金比例" name="RATIO_30" v-model="RATIO_30" :limit="[0,20]" input-unit="%" word="按交易金额抽取对应比例作为省代奖励"></c-form-item>
								<c-form-item v-if="item.id == 20" type="number" decimal="4" style="width:500px" label="市代代理佣金比例" name="RATIO_20" v-model="RATIO_20" :limit="[0,20]" input-unit="%" word="按交易金额抽取对应比例作为市代奖励"></c-form-item>
							</c-form>
							<c-form title="推荐奖励设置">
								<c-form-item v-model="item.is_directly_reward" type="radio" label="直推奖励" :options="directOptions" word="会员用户直接推荐会员用户可获得『直推奖励』"></c-form-item>
								<c-form-item v-show="item.is_directly_reward == 2">
									<c-table v-model="item.directly_reward_list" border height="auto" style="width: 600px;">
										<c-table-column
											label="直推等级"
											name="recommend_level_name"
										></c-table-column>
										<c-table-column
											label="奖励比例 (%)"
										>
											<template v-slot="{data}">
												<c-input v-model="data.reward_money" word="%" v-if="data.recommend_level_id != 40"></c-input>
											</template>
										</c-table-column>
									</c-table>
								</c-form-item>
								<c-form-item v-model="item.is_indirect_reward" type="radio" label="间推奖励" :options="indirectOptions" word="会员用户间接推荐会员用户可获得『间推奖励』"></c-form-item>
								<c-form-item v-show="item.is_indirect_reward == 2">
									<c-table v-model="item.indirect_reward_list" border height="auto" style="width: 600px;">
										<c-table-column
											label="间推等级"
											name="recommend_level_name"
										></c-table-column>
										<c-table-column
											label="奖励比例 (%)"
										>
											<template v-slot="{data}">
												<c-input v-model="data.reward_money" word="%" v-if="data.recommend_level_id != 40"></c-input>
											</template>
										</c-table-column>
									</c-table>
								</c-form-item>
							</c-form>
							
						</c-form>
					</div>
				</c-form-item>
			</c-form>

			<template slot="button">
				<c-button size="m" @click="saveHandle()">提交保存</c-button>
			</template>
		</module>
	</page>
</template>

<script>
	import validate from '@/assets/script/validate.js'
	
	export default {
		name: 'm_share',
		
		data() {
			return {
				levelList: [],
				currentTab: 0,
				
				directOptions: [{
					name: '开启',
					value: 2
				}, {
					name: '关闭',
					value: 1
				}],
				
				indirectOptions: [{
					name: '开启',
					value: 2
				}, {
					name: '关闭',
					value: 1
				}],
				
				commisionOptions: [{
					name: '开启',
					value: 2
				}, {
					name: '关闭',
					value: 1
				}],
				RATIO_40: 0,
				RATIO_30: 0,
				RATIO_20: 0,
			}
		},
		
		mounted() {
			this.request({
				url: '/share/config/detail',
				success: data => {
					this.$refs.form.set(data);
					this.RATIO_20 = ''+data.RATIO_20;
					this.RATIO_30 = ''+data.RATIO_30;
					this.RATIO_40 = ''+data.RATIO_40;
					this.levelList = data.level_list;
				}
			});
		},

		methods: {
			saveHandle() {
				this.$refs.form.submit({
					url: '/share/config/edit',
					rule: {
						share_img_list: '请上传分销海报图'
					},
					dataFormatter: data => {
						data.level_list = this.levelList;
						return data;
					},
					success: () => {
						this.$message({
							text: '保存成功',
							icon: 'success'
						});
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.tab {
		margin-bottom: -1px;

		li {
			width: 100px;
			border: 1px solid #ddd;
			padding: 0 10px;
			margin-right: -1px;
			line-height: 40px;
			font-size: 13px;
			text-align: center;
			color: #000;
			background: #fff;
			cursor: pointer;

			&:hover {
				position: relative;
			theme-border(lesser);
			theme-color(lesser);
			}

			&.z-crt {
				position: relative;
			theme-border(lesser);
				color: #fff;
			theme-background(lesser);
			}
		}
		
		&-content {
			border: 1px solid #ddd;
		}
	}
</style>